export default {
      id: "create-usage",
      viewBox: "0 0 102 75",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#create",
      toString: function () {
        return this.url;
      }
    }